import DOMPurify, { type Config } from 'dompurify';

const domPurify = DOMPurify();

domPurify.addHook('afterSanitizeAttributes', (node) => {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeHtml = (value: string, overrides?: Config) => {
  const config: Config = {
    ...overrides,
    ADD_ATTR: ['target', 'rel'],
    USE_PROFILES: { html: true },
  };
  return domPurify.sanitize(value, config);
};
